export default values => ({
  brand: values && (values.brand || ''),
  model: values && (values.model || ''),
  price: values && (values.price || ''),
  iva: values && (values.iva || ''),
  isMovable: values && (values.isMovable || false)
});
